import { render, staticRenderFns } from "./facebook_login.vue?vue&type=template&id=5ed7e7ca"
import script from "./facebook_login.vue?vue&type=script&lang=js"
export * from "./facebook_login.vue?vue&type=script&lang=js"
import style0 from "./facebook_login.vue?vue&type=style&index=0&id=5ed7e7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports